import React from 'react'
import { useParams } from 'react-router-dom'

import PuzzleEditor from './PuzzleEditor'
import { NEW_PUZZLE_ID, errorMessage, usePuzzle } from './PuzzlesApi'
import './Puzzles.scss'

const PuzzleEditPage = () => {
  const { puzzleId } = useParams<{ puzzleId: string }>()
  const isNew = puzzleId === NEW_PUZZLE_ID
  const detail = usePuzzle(puzzleId)

  if (isNew) return <PuzzleEditor key={NEW_PUZZLE_ID} puzzle={null} />
  if (detail.isLoading) return <div className="pz-empty">Loading puzzle…</div>
  if (detail.isError || !detail.data) {
    return <div className="pz-empty pz-error-text">{errorMessage(detail.error)}</div>
  }
  return <PuzzleEditor key={detail.data.id} puzzle={detail.data} />
}

export default PuzzleEditPage
